<template>
    <v-layout column fill-height class="primary">
        <v-flex xs12 class="d-flex justify-center align-center theme--dark">
            <v-layout column>
                <v-flex class="white--text headline text-center">
                    {{message}}
                </v-flex>
                <v-flex class="white--text body-1 text-center">
                    {{acknowledgment}}
                </v-flex>
                <v-flex class="white--text body-1 text-center">
                    {{enjoy}}
                </v-flex>
            </v-layout>
            <span class="body-2">
            </span>
        </v-flex>
    </v-layout>
</template>

<script>
    import SettingsService from "../services/settingsService";

    export default {
        name: "Redirect",
        data() {
            return {
                // message: 'Bem-vindo ao Beach Park',
                message: 'Bem-vindo ao PDV XS',
                acknowledgment: "Estamos direcionando você para o acesso ao cardápio.",
                enjoy: "Bom apetite!"
            }
        },
        mounted() {
            setTimeout(async () => {
                const res = await new SettingsService().getAccessPointURL(this.$route.params.pdv, this.$route.params.number)
                if (res.data.url === "") {
                    this.message = 'Não encontramos essa mesa'
                    this.acknowledgment = 'tem certeza que digitou a URL corretamente?'
                    this.enjoy = ''
                    return
                }
                localStorage.clear()
                window.location.replace(res.data.url);
            }, 2000)
        }
    }
</script>

<style scoped>

</style>